import { AmpVideoLink } from "types/amplience";
import { buildImageHost } from "./buildImageURL";
import { Brand } from "types/common";

const buildVideoSources = (video: AmpVideoLink, brand: Brand) => {
  const imageHost = buildImageHost(video.defaultHost, brand);

  const url = new URL(`https://${imageHost}/v/${video.endpoint}/${video.name}`);

  // First iteration of set srcs
  return [
    {
      src: `${url}/l_mp4_764x500`,
      type: "mp4",
    },
    {
      src: `${url}/l_webm_764x500`,
      type: "webm",
    },
  ];
};

export default buildVideoSources;
